
import { RichText } from '@wordpress/block-editor';
import BlockContext from "../context/blockContext";
import { useContext } from "@wordpress/element";
import SectionItemContext from "../context/sectionItemContext";

function Reference() {
    const { updateField, scrollToSection, toggleReferencePanel } = useContext(BlockContext);
    const { item, index, itemIndex } = useContext(SectionItemContext);
  return (
    <div
        className="cv-reference"
        onClick={() => scrollToSection("section8")}
        onClick={toggleReferencePanel}
    >
        <RichText
        tagName="div"
        className="name"
        value={item.name}
        onChange={(value) => updateField(index, "name", value, itemIndex)}
        />
        <>
        <RichText
            tagName="span"
            className="company"
            value={item.company}
            onChange={(value) => updateField(index, "company", value, itemIndex)}
        />
        {item.company && ", "}
        </>
        <RichText
        tagName="span"
        className="job-position"
        value={item.jobPosition}
        onChange={(value) => updateField(index, "jobPosition", value, itemIndex)}
        />
        <RichText
        tagName="div"
        className="phone"
        value={item.phone}
        onChange={(value) => updateField(index, "phone", value, itemIndex)}
        />
        <RichText
        className="relation"
        value={item.relation}
        onChange={(value) => updateField(index, "relation", value, itemIndex)}
        />
    </div>
  )
}

export default Reference
